// extracted by mini-css-extract-plugin
export default {"page":"Upsell_page__loJmk","imageWrapper":"Upsell_imageWrapper__ko4BI","copyTextWrapper":"Upsell_copyTextWrapper__ExRES"};